import React from 'react';

import { Card, Form } from 'antd';

interface FilterPanelProps {
  id?: string;
  children: React.ReactNode;
}

export function FilterPanel({ id, children }: FilterPanelProps) {
  return (
    <Card
      id={id}
      variant='borderless'
      className='mb-6 bg-(--uizz-antd-color-fill-tertiary) shadow-none'
      classNames={{ body: 'p-(--uizz-antd-padding-lg)' }}
    >
      <Form layout='vertical' component='div' size='small' className='w-full'>
        {children}
      </Form>
    </Card>
  );
}

export default FilterPanel;
